
import styles from "./PartWorkItemReport.module.scss";
import { useState } from "react";
import { useTranslation } from 'react-i18next';

import checkicon from 'assets/icons/check.png'
import circleicon from 'assets/icons/circle.png'
import squareicon from 'assets/icons/square.png'
import checksquareicon from 'assets/icons/square_check.png'
import pieeeeechart from 'assets/icons/pieeeeechart.png'
import Notification from "utils/Notifications";
import { PieChart } from 'react-minimal-pie-chart'
import { removeAnswer, moveAnswerUp, moveAnswerDown } from "service/TestService";
import { EditorState, convertFromRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";


const PartWorkItemReport = ({ item, index, setRender, MassLength, ChangeRowOn }) => {
    const { t } = useTranslation('common');

    const [notify, setNotify] = useState({
        isOpen: false,
        message: "",
        type: "",
    });

    const generateUniqueColor = (usedColors) => {
        let color;
        do {
            color = `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')}`;
        } while (color === "#ffffff" || usedColors.has(color)); 
        usedColors.add(color);
        return color;
    };

    const usedColors = new Set();
    const DraftContent = ({ draftData }) => {
        let contentState;
        try {
            const parsedData = typeof draftData === "string" ? JSON.parse(draftData) : draftData;
            contentState = convertFromRaw(parsedData);

            if (!parsedData?.blocks[0]?.text) {
                return null

            }
        } catch (error) {
            return <p>Invalid content format</p>;
        }

        const editorState = EditorState.createWithContent(contentState);

        return (
            <div st>
                <Editor editorState={editorState} readOnly toolbarHidden />
            </div>
        );
    };

    const pieChartData = item.answer_part_worktest
        .filter(answer => answer.times_selected_percent !== 0) 
        .map(answer => ({
            id_chipolino: answer.id,
            title: <DraftContent draftData={answer.title} />,
            value: answer.times_selected_percent,
            text: `${answer.times_selected_percent} (${answer.times_selected})`,
            color: generateUniqueColor(usedColors),
        }));


    const [text, setText] = useState('');
    const maxLength = 1000;  

    const handleChange = (event) => {
        setText(event.target.value);
    };

    const [file, setFile] = useState(null);

    const handleFileChange_test = (e) => {
        setFile(e.target.files[0]);
    };

    return (


        <div className={styles.answer_card_selection}>
      
            <div className={styles.answer_card_selection_header}>


                <h2 className={styles.answer_card_selection_header_h2} key={index}>
                    <span>
                        <img
                            src={pieeeeechart}
                            className={styles.img}
                            alt='sdfsd'
                        />

                        {Math.max(
                            item.max_points_for_the_correct_answer,
                            item.points_for_the_correct_answer,
                            item.points_for_the_wrong_answer,
                            ...item.answer_part_worktest.map(answer => answer.points)
                        )}
                    </span>
                    <span>
                        {item.part_number}/{MassLength}</span></h2>
            </div>
            {item.image &&
                <img
                    src={item.image}
                    className={styles.img_file}
                />
            }
            <div className={styles.answer_card_selection_body}>

                <DraftContent draftData={item.body} />
                <div className={styles.answer_card_selection_leeRATE}>
                    <div className={styles.answer_card_selection_body_answer}>
                        {item.answer_part_worktest.map((answer, index) => (
                            <div style={{ width: '100%' }}>
                                {(item.type_answer !== "freeTextAnswer" && item.type_answer !== "infoText" && item.type_answer !== 'fileUpload') ? (
                                    <div className={styles.answer_card_header}>

                                        {(item.checkpoints === true && item.type_answer !== 'numericInput' && item.type_answer !== 'textInput' && item.type_answer !== "slider" && item.type_answer !== 'sequenceOrdering') &&
                                            <img
                                                src={answer.points > 0 ? checkicon : circleicon}
                                                className={styles.img}
                                            />
                                        }

                                        {(item.checkpoints === false && item.type_answer !== 'numericInput' && item.type_answer !== 'textInput' && item.type_answer !== "slider" && item.type_answer !== 'sequenceOrdering') &&
                                            <img
                                                src={answer.right_answer === true ? checksquareicon : squareicon}
                                                className={styles.img}
                                            />
                                        }
                                        {(item.type_answer === 'sequenceOrdering') &&
                                            <>
                                                <DraftContent draftData={answer.title} />
                                                <select
                                                    className={styles.point_check_num_text}
                                                    value={answer.sequences_selectedNumber}  

                                                >
                                                    <option value={answer.sequences_selectedNumber}>{answer.sequences_selectedNumber}</option>
                                                </select>
                                            </>
                                        }
                                        {(item.type_answer === 'slider') &&
                                            <div style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: "5px" }}>
                                                <div>
                                                    <h4 >{answer.type_input_txt}</h4>

                                                </div>
                                                <div className={styles.slider_min_max}>
                                                    <h4>{Math.min(Number(answer.min_len), Number(answer.max_len))}</h4>
                                                    <input
                                                        id="slider"
                                                        type="range"
                                                        min={Math.min(Number(answer.min_len), Number(answer.max_len))}
                                                        max={Math.max(Number(answer.min_len), Number(answer.max_len))}
                                                        value={answer.ranswer}
                                                        style={{ width: '100%' }}
                                                    />
                                                    <h4>{Math.max(Number(answer.min_len), Number(answer.max_len))}</h4>
                                                    <h4 className={styles.slider_right_answer}> <img
                                                        src={checksquareicon}
                                                        className={styles.img}
                                                    />{answer.ranswer}</h4>
                                                </div>
                                            </div>
                                        }
                                        {(item.type_answer === 'numericInput') &&
                                            <h4 style={{ border: '1px solid rgb(41, 33, 33)', padding: '5px 10px' }}>{answer.type_input_int}</h4>
                                        }
                                        {(item.type_answer === 'textInput') &&
                                            <h4 style={{ border: '1px solid rgb(123, 123, 123)', padding: '5px 10px' }}>{answer.type_input_txt}</h4>
                                        }
                                        {(item.type_answer === 'singleSelection' || item.type_answer === 'multipleSelection') &&
                                            <div style={{ borderBottom: "1px solid #1100d2" }}><DraftContent draftData={answer.title} />     <span className={styles.chart_info} ><div
                                                style={{
                                                    width: '20px',
                                                    height: '20px',
                                                    backgroundColor: pieChartData.find(data => data.id_chipolino === answer.id)?.color, 
                                                    marginRight: '8px',
                                                    borderRadius: '5px',
                                                }}

                                            ></div>{t('tests.report.respondents_chose', { percent: answer.times_selected_percent, count: answer.times_selected })}</span> </div>
                                        }
                                    </div>
                                ) : (
                                    <>
                                        {item.type_answer === "freeTextAnswer" && (
                                            <div className={styles.answer_card_header}>
                                                <div className={styles.answer_card_second_div} >
                                                    {t('tests.report.free_format_question')}
                                                </div>
                                            </div>

                                        )}
                                        {item.type_answer === "fileUpload" && (
                                            <div className={styles.answer_card_header}>
                                                <div className={styles.answer_card_second_div} >
                                                    {t('tests.report.free_format_question')}
                                                </div>
                                            </div>
                                        )}

                                    </>
                                )}
                                {answer.file &&
                                    <img
                                        src={answer.file}
                                        className={styles.img_file}
                                    />
                                }
                            </div>
                        ))}
                    </div>
                    <div className={styles.answer_card_selection_leeRATE2}>
                        {(item.type_answer === 'singleSelection' || item.type_answer === 'multipleSelection') &&
                            <div className={styles.pie_size}>
                                <PieChart
                                    animate
                                    animationDuration={1000}
                                    animationEasing="ease-in"
                                    center={[50, 50]}
                                    data={pieChartData}
                                    lengthAngle={360}
                                    lineWidth={40}
                                    paddingAngle={3}
                                    radius={50}
                                    startAngle={0}
                                    label={({ dataEntry }) => ` ${dataEntry.value}%`}
                                    labelPosition={77}
                                    labelStyle={{
                                        fontSize: '8px',
                                        fontColor: 'FFFFFА',
                                        fontWeight: '800',
                                        lineHeight: '1em',
                                    }}
                                    className={styles.answer_card_selection_leeRATE2_chart}

                                />
                            </div>
                        }
                    </div>
                </div>
                {item?.comment !== null &&
                    <div style={{ marginTop: '40px', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>


                        <DraftContent draftData={item.comment} />

                    </div>
                }

            </div>

            <hr></hr>
            <Notification notify={notify} setNotify={setNotify} />
        </div >


    );
};

export default PartWorkItemReport;
